var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'规则配置',path:'/shop/plugin/points-mall/conf'},
    {title:'商品管理',path:'/shop/plugin/points-mall/goods'},
    {title:'兑换订单',path:'/shop/plugin/points-mall/order'},
    {title:'用户管理',path:'/shop/plugin/points-mall/user'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }